export const PRACTICE_TEST = [
    {
        id: 1,
        test_name: 'Assessment Test',
        use_practice_test_id: true,
        practice_test_id: 1,
        requires_subscription: false
    },
    {
        id: 2,
        test_name: 'Practice Test 1',
        use_practice_test_id: true,
        practice_test_id: 2,
        requires_subscription: true
    },
    {
        id: 3,
        test_name: 'Practice Test 2',
        use_practice_test_id: true,
        practice_test_id: 3,
        requires_subscription: true
    },
    {
        id: 4,
        test_name: 'Practice Test 3',
        use_practice_test_id: true,
        practice_test_id: 4,
        requires_subscription: true
    },
    {
        id: 5,
        test_name: 'Practice Test 4',
        use_practice_test_id: true,
        practice_test_id: 5,
        requires_subscription: true
    },
    {
        id: 6,
        test_name: 'Practice Test 5',
        use_practice_test_id: true,
        practice_test_id: 6,
        requires_subscription: true
    },
    {
        id: 7,
        test_name: 'Practice Test 6',
        use_practice_test_id: true,
        practice_test_id: 7,
        requires_subscription: true
    }
];

export const APP_DOMAIN_LIST = [
    {
        id: 1,
        domain_name: "Basic AI concepts related to cybersecurity",
        show_proficiency: true,
        icon: 'book-open-variant',
        requires_subscription: false,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 5,
    },
    {
        id: 2,
        domain_name: "Securing AI systems",
        show_proficiency: true,
        icon: 'shield-account',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 5,
    },
    {
        id: 3,
        domain_name: "AI-assisted security",
        show_proficiency: true,
        icon: 'sitemap',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 5,
    },
    {
        id: 4,
        domain_name: "AI governance, risk, and compliance",
        show_proficiency: true,
        icon: 'account-lock',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 5,
    }
];

export const QUESTION_VERSION_OF_JSON = 1
